import { useMemo } from 'react';

import useAuth from '@/hooks/useAuth';
import SubscriptionStatus from '@/types/SubscriptionStatus';

/**
 * Custom hook for centralized subscription status checks
 * Provides primary subscription status flags - derive complex logic locally
 */
export function useSubscriptionStatus() {
  const { platformSubscriptionStatus } = useAuth();

  const subscriptionFlags = useMemo(() => {
    return {
      isActive: platformSubscriptionStatus === SubscriptionStatus.ACTIVE,
      isInactive: platformSubscriptionStatus === SubscriptionStatus.INACTIVE,
      isFree: platformSubscriptionStatus === SubscriptionStatus.FREE,
    };
  }, [platformSubscriptionStatus]);

  return {
    platformSubscriptionStatus,
    ...subscriptionFlags,
  };
}

export default useSubscriptionStatus;
